var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 9.625V4.375H21V6.125H12.25V3.5C12.2493 3.03608 12.0647 2.59137 11.7367 2.26333C11.4086 1.93529 10.9639 1.75069 10.5 1.75H3.5C3.03608 1.75069 2.59137 1.93529 2.26333 2.26333C1.93529 2.59137 1.75069 3.03608 1.75 3.5V10.5C1.75069 10.9639 1.93529 11.4086 2.26333 11.7367C2.59137 12.0647 3.03608 12.2493 3.5 12.25H10.5C10.9639 12.2493 11.4086 12.0647 11.7367 11.7367C12.0647 11.4086 12.2493 10.9639 12.25 10.5V7.875C12.946 7.87569 13.6133 8.15248 14.1054 8.64461C14.5975 9.13674 14.8743 9.80402 14.875 10.5V18.375H9.625V16.625H4.375V21.875H9.625V20.125H14.875V21.875C14.8757 22.3389 15.0603 22.7836 15.3883 23.1117C15.7164 23.4397 16.1611 23.6243 16.625 23.625H21V25.375H26.25V20.125H21V21.875H16.625V15.75H21V17.5H26.25V12.25H21V14H16.625V10.5C16.6219 9.55034 16.3068 8.62801 15.7281 7.875H21V9.625H26.25ZM3.5 10.5V3.5H10.5V10.5H3.5ZM7.875 20.125H6.125V18.375H7.875V20.125ZM22.75 21.875H24.5V23.625H22.75V21.875ZM22.75 14H24.5V15.75H22.75V14ZM22.75 6.125H24.5V7.875H22.75V6.125Z",
    fill: "#80c5d6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.ef8a1c0ce262fe44bafb1242ba331be6.svg";
export { ForwardRef as ReactComponent };